export default __webpack_public_path__ + "media/color/san-796d43a2.svg";